import {
    FETCH_SEUIL_PASSAGE_REQUEST, FETCH_SEUIL_PASSAGE_SUCCESS, FETCH_SEUIL_PASSAGE_FAILURE,
    CREATE_SEUIL_PASSAGE_REQUEST, CREATE_SEUIL_PASSAGE_SUCCESS, CREATE_SEUIL_PASSAGE_FAILURE,
    UPDATE_SEUIL_PASSAGE_REQUEST, UPDATE_SEUIL_PASSAGE_SUCCESS, UPDATE_SEUIL_PASSAGE_FAILURE,
    DELETE_SEUIL_PASSAGE_REQUEST, DELETE_SEUIL_PASSAGE_SUCCESS, DELETE_SEUIL_PASSAGE_FAILURE
} from '../actions/seuilPassageActions';

const initialState = {
    list: [],
    loading: false,
    error: null,
};

const seuilPassageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SEUIL_PASSAGE_REQUEST:
        case CREATE_SEUIL_PASSAGE_REQUEST:
        case UPDATE_SEUIL_PASSAGE_REQUEST:
        case DELETE_SEUIL_PASSAGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_SEUIL_PASSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.payload,
                error: null
            };

        case CREATE_SEUIL_PASSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                list: [...state.list, action.payload],
                error: null
            };

        case UPDATE_SEUIL_PASSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map(seuil => 
                    seuil.id === action.payload.id ? action.payload : seuil
                ),
                error: null
            };

        case DELETE_SEUIL_PASSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.filter(seuil => seuil.id !== action.payload),
                error: null
            };

        case FETCH_SEUIL_PASSAGE_FAILURE:
        case CREATE_SEUIL_PASSAGE_FAILURE:
        case UPDATE_SEUIL_PASSAGE_FAILURE:
        case DELETE_SEUIL_PASSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default seuilPassageReducer;
